import {api} from "../../utils/api";
import store from '../store'
import Vue from 'vue'

export default {

    /**
     * Set tasks
     * @param state
     * @param tasks
     * @constructor
     */
    INIT_TASKS(state, tasks) {

        // Nothing to do
        if (!tasks) return;

        // Tasks can be a single task or tasks list
        if (!Array.isArray(tasks)) tasks = [tasks];

        // Item
        let i;

        // Reset tasks and index
        state.tasks = {};
        state.treeTasks = {};

        // Save each task from list to state
        for (i of Object.values(tasks)) {

            // Store task
            Vue.set(state.tasks, i.id, i);

            // Store tree tasks
            Vue.set(state.treeTasks, i.id, {original_task_id: i.original_task_id, id: i.id, state: i.state, deferred: i.deferred, parent_id: i.parent_id, type: i.type, position: i.position});

            if (!state.tree[i.parent_id]) Vue.set(state.tree, i.parent_id, {});
            Vue.set(state.tree[i.parent_id], i.id, 1);
        }
    },

    /**
     * Set tasks
     * @param state
     * @param tasks
     * @constructor
     */
    SET_TASKS(state, tasks) {

        // Nothing to do
        if (!tasks) return;

        // Tasks can be a single task or tasks list
        if (!Array.isArray(tasks)) tasks = [tasks];

        // Item
        let i;

        // Save each task from list to state
        for (i of Object.values(tasks)) {

            // Get old task
            const oldParent = state.tasks[i.id] ? state.tasks[i.id].parent_id : 0;
            const oldTree = state.treeTasks[i.id] ? state.treeTasks[i.id] : {};

            // Check is task deleted
            if (i.deleted_at) {

                // Delete old root
                if(oldParent) Vue.delete(state.tree[oldParent], i.id);

                // Delete task
                Vue.delete(state.tasks, i.id);
                Vue.delete(state.treeTasks, i.id);

            } else {

                // Check for changed parent
                if(oldParent && i.parent_id && oldParent !== i.parent_id) {
                    // Delete old root
                    Vue.delete(state.tree[oldParent], i.id);
                }

                if (!state.tree[i.parent_id]) Vue.set(state.tree, i.parent_id, {});
                if(!state.tree[i.parent_id][i.id]) Vue.set(state.tree[i.parent_id], i.id, 1);

                // Store task
                Vue.set(state.tasks, i.id, api.mergeObjects(state.tasks[i.id], i));

                // Store tree tasks if changed
                if(api.isChanged(i, oldTree, ['state', 'deferred', 'parent_id', 'type', 'position'])) {
                    Vue.set(state.treeTasks, i.id, {id: i.id, state: i.state, deferred: i.deferred, parent_id: i.parent_id, type: i.type, position: i.position});
                    //console.log(i.id, oldTree, i);
                }

            }
        }
    },

    /**
     * Invalidate task
     * @param state
     * @param id
     * @constructor
     */
    INVALIDATE_TASK(state, id) {
        // Re-set value
        if (state.tasks[id]) {
            Vue.set(state.tasks[id], 'upd', Math.random());
        }
    },


    /**
     * Set dependecies
     * @param state
     * @param campaigns
     * @constructor
     */
    SET_DEPENDENCY(state, deps) {
        // Store task
        Vue.set(state.tasks[deps.id], 'dependencies', deps.dependencies);
    },

    /**
     * Reset tasks
     * @param state
     * @param campaigns
     * @constructor
     */
    RESET_TASKS(state, tasks) {

        // Save each task from list to state
        state.tasks = {};

        // Update positions
        this.commit('tree/SET_TASKS', tasks);

    },

    /**
     * Expand task
     * @param state
     * @param task
     * @constructor
     */
    EXPAND_TASK(state, {id, expanded}) {

        // Save each task from list to state
        if (state.tasks[id]) {
            Vue.set(state.tasks[id], 'expanded', expanded);

            // Index expanded
            if(expanded == 1) Vue.set(state.expandedNodes, id, 1); else Vue.delete(state.expandedNodes, id);
        }
    },

    /**
     * Show closed children
     * @param state
     * @param task
     * @constructor
     */
    SHOW_CLOSED_CHILDREN(state, {id, mode}) {

        // Save each task from list to state
        if (state.treeTasks[id]) {
            Vue.set(state.treeTasks[id], 'show_closed_children', mode);
        }
    },

    /**
     * Show await children
     * @param state
     * @param task
     * @constructor
     */
    SHOW_AWAIT_CHILDREN(state, {id, mode}) {

        // Save each task from list to state
        if (state.treeTasks[id]) {
            Vue.set(state.treeTasks[id], 'show_await_children', mode);
        }
    },

    /**
     * Show deferred children
     * @param state
     * @param task
     * @constructor
     */
    SHOW_DEFERRED_CHILDREN(state, {id, mode}) {

        // Save each task from list to state
        if (state.treeTasks[id]) {
            Vue.set(state.treeTasks[id], 'show_deferred_children', mode);
        }
    },

    /**
     * Expand path
     * @param state
     * @param campaigns
     * @constructor
     */

    EXPAND_PATH(state, id) {

        // Get path
        for (let pID of store.getters['tree/getTasksParents'](id)) {
            // Expand pos
            if (id != pID) this.commit('tree/EXPAND_TASK', {id: pID, expanded: 1});
        }
    },

    /**
     * Set active task
     * @param state
     * @param campaigns
     * @constructor
     */
    ACTIVE_TASK(state, id) {

        // Save each task from list to state
        Vue.set(state, 'activeTaskID', id);
    },

    /**
     * Set copy task
     * @param state
     * @param campaigns
     * @constructor
     */
    COPY_TASK(state, id) {

        // Store id of task to be copied
        Vue.set(state, 'copyTaskID', id);
    },

    /**
     * Set active task field
     * @param state
     * @param campaigns
     * @constructor
     */
    ACTIVE_TASK_FIELD(state, payload) {

        // Save each task from list to state
        Vue.set(state, 'activeTaskField', payload);
    },

    /**
     * Set tasks list gui mode
     * @param state
     * @param campaigns
     * @constructor
     */
    TASK_LIST_MODE(state, mode) {

        // Save each task from list to state
        Vue.set(state, 'tasksListMode', mode);
    },

    /**
     * Set tasks list query string
     * @param state
     * @param query
     * @constructor
     */
    SET_TASK_LIST_QUERY(state, query) {

        // Save each task from list to state
        Vue.set(state, 'tasksListQuery', query);
    },

    /**
     * Set tasks list tags
     * @param state
     * @param tags
     * @constructor
     */
    SET_TASK_LIST_TAGS(state, tags) {

        // Save each task from list to state
        Vue.set(state, 'tasksListTags', tags);

    },

    /**
     * Set tree notification filter
     * @param state
     * @param tags
     * @constructor
     */
    SET_TREE_NOTIFICATION_FILTER(state, notType) {

        // Save each task from list to state
        Vue.set(state, 'treeNotificationFilter', notType);

    },

    /**
     * Set last upate time
     * @param state
     * @param tags
     * @constructor
     */
    SET_LAST_UPDATE(state, time) {
        // Save time in case of not empty answer
        if (time.lastTime) {
            // Set last update time
            Vue.set(state, 'lastUpdateTime', time.lastTime);
        }
    },

    /**
     * Delete task
     * @param state
     * @param tasks
     * @constructor
     */
    DELETE_TASKS(state, tasks) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(tasks)) tasks = [tasks];

        // Save each task from list to state
        tasks.forEach(i => {
            //Vue.delete(state.tasks, i.id);
            if (state.tasks[i.id]) {
                Vue.set(state.tasks[i.id], 'deleted_at', 1);
                Vue.set(state.treeTasks[i.id], 'deleted_at', 1);
            }
        });
    },


    /**
     * Set task notifications
     * @param state
     * @param campaigns
     * @constructor
     */
    SET_TASK_NOTIFICATIONS(state, nots) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(nots)) nots = [nots];

        // Save notifications
        nots.forEach(i => {
            // Store task
            Vue.set(state.taskNotification, i.id, i);
        });
    },


    /**
     * Update hash
     * @param state
     * @param campaigns
     * @constructor
     */
    UPDATE_HASH(state) {

        // Update hash value
        state.updateHash++;

    },


    /**
     * Set current task
     * @param state
     * @param campaigns
     * @constructor
     */
    SET_CURRENT(state, cur) {

        // Apply values
        Vue.set(state, 'currentTask', cur.id);

        // Set spent time into the task
        if (cur.id && state.tasks[cur.id]) Vue.set(state.tasks[cur.id], 'time_spent', cur.time_spent);
    },

    /**
     * Increase time for current task
     * @param state
     * @constructor
     */
    INC_CURRENT_TIME_1SEC(state) {

        // Apply values
        if (state.currentTask && state.tasks[state.currentTask]) {

            // Init if not set
            if (!state.tasks[state.currentTask].time_spent) state.tasks[state.currentTask].time_spent = 0;

            // Increase time
            Vue.set(state.tasks[state.currentTask], 'time_spent', parseInt(state.tasks[state.currentTask].time_spent) + 1);
        }
    },

    /**
     * Set loaded flag
     * @param state
     * @constructor
     */
    SET_LOADED(state, id) {
        // Set loaded flag
        state.loaded[id] = 1;
    },

    /**
     * Set filtered by tasks
     * @param state
     * @param ids
     * @constructor
     */
    SET_FILTERED_BY_TASKS(state, ids) {

        // Check for simple array and convert to object
        if(Array.isArray(ids)) {
            let obj = {}
            ids.forEach(el => obj[el] = el)
            ids = obj
        }

        // Set loaded flag
        Vue.set(state, 'filterByTasks', ids);
    }

}
